import { render, staticRenderFns } from "./InstitutionPageHero.vue?vue&type=template&id=a6b78b5e&"
import script from "./InstitutionPageHero.vue?vue&type=script&lang=js&"
export * from "./InstitutionPageHero.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionPageHero.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports